import types from './types';

const INITIAL_STATE = {
  isSubmittingMeasure: false,
  isSavingHedisClaim: false,
  updatingClaimStatus: false,
  validatingHedisClaim: false,

  result: [],
};

const claimGeneratorReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.SUBMIT_MEMBER_MEASURE_REQUEST:
      return {
        ...state,
        result: [],
        isSubmittingMeasure: true,
      };

    case types.SUBMIT_MEMBER_MEASURE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isSubmittingMeasure: false,
      };

    case types.SUBMIT_MEMBER_MEASURE_FAILURE:
      return {
        ...state,
        result: [],
        isSubmittingMeasure: false,
      };

    case types.SAVE_HEDIS_CLAIM_REQUEST:
      return {
        ...state,
        result: [],
        isSavingHedisClaim: true,
      };

    case types.SAVE_HEDIS_CLAIM_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isSavingHedisClaim: false,
      };

    case types.SAVE_HEDIS_CLAIM_FAILURE:
      return {
        ...state,
        result: [],
        isSavingHedisClaim: false,
      };

    case types.SAVE_CLAIM_STATUS_REQUEST:
      return {
        ...state,
        result: [],
        updatingClaimStatus: true,
      };

    case types.SAVE_CLAIM_STATUS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        updatingClaimStatus: false,
      };

    case types.SAVE_CLAIM_STATUS_FAILURE:
      return {
        ...state,
        result: [],
        updatingClaimStatus: false,
      };

    case types.VALIDATE_HEDIS_CLAIM_REQUEST:
      return {
        ...state,
        result: [],
        validatingHedisClaim: true,
      };

    case types.VALIDATE_HEDIS_CLAIM_SUCCESS:
      return {
        ...state,
        result: action.payload,
        validatingHedisClaim: false,
      };

    case types.VALIDATE_HEDIS_CLAIM_FAILURE:
      return {
        ...state,
        result: [],
        validatingHedisClaim: false,
      };

    default:
      return state;
  }
};

export default claimGeneratorReducer;
